<template>
  <div class="basic_wrap language-page">
    <div class="red_top_bg page-top">
      <div
        class="back_left"
        @click="$router.go(-1)"
      />
      <div class="big_tit">
        {{ $t('safe.language') }}
      </div>
    </div>

    <div class="language-card">
      <button
        v-for="item in languageOptions"
        :key="item.value"
        type="button"
        class="language-item"
        :class="lang == item.value ? 'is-active' : ''"
        @click="changeLang(item.value)"
      >
        <span class="language-left">
          <img
            :src="item.icon"
            alt=""
          >
          <span class="info">{{ item.label }}</span>
        </span>
        <van-icon
          v-if="lang == item.value"
          name="success"
          class="check-icon"
        />
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Icon, Toast } from "vant";

Vue.use(Icon);

export default {
	name: "Language",
	data() {
		return {
			lang: this.$i18n.locale || "en_us",
			languageOptions: [
				{ value: "ko_kr", label: "한국인", icon: require("../images/language/ko_kr.png") },
				{ value: "en_us", label: "English", icon: require("../images/language/en_us.png") },
				{ value: "pt_br", label: "Português", icon: require("../images/language/pt_br.png") },
				{ value: "ja_jp", label: "日本語", icon: require("../images/language/ja_jp.png") },
				// { value: "zh_hk", label: "Español", icon: require("../images/language/es_spa.png") },
				{ value: "th_th", label: "ภาษาไทย", icon: require("../images/language/th_th.png") },
				{ value: "vi_vn", label: "Tiếng Việt", icon: require("../images/language/vi_vn.png") },
				{ value: "id_ind", label: "Indonesia", icon: require("../images/language/id_ind.png") },
				{ value: "ms_my", label: "Melayu", icon: require("../images/language/ms_my.png") },
				{ value: "zh_hk", label: "繁體中文", icon: require("../images/language/zh_hk.png") },
				
			],
		};
	},
	methods: {
		changeLang(lang) {
			Toast.loading({
				duration: 200,
			});
			this.lang = lang;
			this.$i18n.locale = lang;
			localStorage.setItem("lang", lang);
			this.$router.go(-1);
		},
	},
};
</script>

<style lang="less" scoped>
.language-page {
	min-height: 100vh;
	background: #fff;
	color: #16223a;
	padding-bottom: 80px;
	box-sizing: border-box;
}

.page-top {
	height: 44px;
	background: #fff;
	color: #16223a;
	border-bottom: 1px solid rgba(240, 242, 245, 1);
	box-sizing: border-box;

	.back_left {
		opacity: 0.88;
	}

	.big_tit {
		color: #16223a;
	}
}

.language-card {
	margin: 16px 16px 0;
	overflow: hidden;
	border-radius: 14px;
	border: 1px solid rgba(255, 93, 122, 0.16);
	background: #fff;
	box-shadow: 0 12px 22px rgba(22, 34, 58, 0.08);
}

.language-item {
	width: 100%;
	min-height: 58px;
	padding: 0 18px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border: 0;
	border-bottom: 1px solid rgba(240, 242, 245, 1);
	background: transparent;
	color: #16223a;
	font-size: 14px;
	font-weight: 700;
	text-align: left;
	box-sizing: border-box;
}

.language-item:last-child {
	border-bottom: 0;
}

.language-item.is-active {
	background: rgba(255, 93, 122, 0.12);
}

.language-left {
	min-width: 0;
	display: flex;
	align-items: center;
}

.language-left img {
	width: 34px;
	height: 34px;
	flex: 0 0 34px;
	border-radius: 50%;
	object-fit: cover;
}

.info {
	min-width: 0;
	margin-left: 12px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.check-icon {
	flex: 0 0 auto;
	margin-left: 12px;
	color: #12ed72;
	font-size: 18px;
}

@media screen and (max-width: 374px) {
	.language-card {
		margin-right: 12px;
		margin-left: 12px;
	}
}
</style>
